import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NouisliderModule } from 'ng2-nouislider';
import { TagInputModule } from 'ngx-chips';
import { SelectModule } from 'ng2-select';
import { UploadunedaComponent} from './uploaduneda.component';

import { UploadunedaRoutes } from './uploaduneda.routing';
import { MaterialModule } from '../app.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [
      SharedModule,
        CommonModule,
        RouterModule.forChild(UploadunedaRoutes),
        FormsModule,
        ReactiveFormsModule,
    NouisliderModule,
    TagInputModule,
    MaterialModule
    ],
    entryComponents: [UploadunedaComponent],
    declarations: [UploadunedaComponent]
})

export class UploadunedaModule {}